import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { putArrivalFlightEdit } from "./functions";
import { useDispatch } from "react-redux";
import { sectorArray } from "./ArrivalOnboarding";
import { CgSpinner } from "react-icons/cg";
import reverseDate from "./../../../../utils/reverseDate";

export default function EditPopup({ popupState, setPopupState, setTableData }) {
  const dispatch = useDispatch();
  const flightId = popupState?.flightId;
  const currentData = popupState?.currentData;

  const [finalObj, setFinalObj] = useState({});
  const [disable, setDiasble] = useState(true);

  const [submitLoading, setSubmitLoading] = useState(false);

  const formatDate = (dateString) => {
    if (dateString) {
      var date = new Date(dateString);
      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var formattedDate = year + "-" + month + "-" + day;
      console.log(dateString, formattedDate);
      return formattedDate;
    }
  };

  const handleGroupEdit = async (e) => {
    e.preventDefault();
    const body = { ...finalObj };
    for (let key in body) {
      if (body[key] == "") {
        delete body[key];
      }
    }
    console.log(body);
    const response = await putArrivalFlightEdit(
      body,
      flightId,
      setSubmitLoading,
      setTableData,
      dispatch
    );
    if (response.completed) {
      setPopupState({ open: false });
    }
  };

  useEffect(() => {
    let isEmpty = Object.keys(finalObj).length == 0;
    if (!isEmpty) {
      setDiasble(false);
    } else {
      setDiasble(true);
    }
  }, [finalObj]);
  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        popupState.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-xl w-full h-auto min-h-[15rem] max-h-[35rem] rounded-md bg-white/95 flex  flex-col p-4 relative overflow-y-scroll">
        <div className="flex justify-between items-center w-full">
          <div>
            <h1 className="text-xl font-semibold">Edit Flight Details</h1>
            <h2 className="text-sm">Edit Arrival Flight Details</h2>
          </div>
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              setPopupState((p) => ({ open: false }));
            }}
          >
            <IoMdClose />
          </h1>
        </div>
        <form className="px-5 py-2 mt-5" onSubmit={handleGroupEdit}>
          {/* <TextInput
            title="Flight Details"
            objKey="flight_detail"
            setFinalObj={setFinalObj}
            defaultValue={currentData?.flight_details}
          />
          <TextInput
            title="Country"
            objKey="country"
            setFinalObj={setFinalObj}
            defaultValue={currentData?.country}
          />
          <TextInput
            title="Date of Departure"
            objKey="date_of_departure"
            setFinalObj={setFinalObj}
            type="date"
            defaultValue={formatDate(currentData?.date_of_departure)}
          />
          <TextInput
            title="Time of Departure"
            objKey="time_of_departure"
            setFinalObj={setFinalObj}
            type="time"
            defaultValue={currentData?.time_of_departure}
          />
          <TextInput
            title="Date of Arrival"
            objKey="date_of_arrival"
            setFinalObj={setFinalObj}
            type="date"
            defaultValue={formatDate(currentData?.date_of_arrival)}
          />
          <TextInput
            title="Time of Arrival"
            objKey="time_of_arrival"
            setFinalObj={setFinalObj}
            type="time"
            defaultValue={currentData?.time_of_arrival}
          />
          <ArraySelectInput
            title="Select Sector"
            array={sectorArray}
            objKey="sector_id"
            setFinalObj={setFinalObj}
            defaultValue={currentData?.sector_id}
          />
          <TextInput
            title="Pickup to be Arranged"
            objKey="pickup_to_be_arranged"
            setFinalObj={setFinalObj}
            defaultValue={currentData?.pickup_to_be_arranged}
          />
          <TextInput
            title="Project Incharge"
            objKey="project_incharge"
            setFinalObj={setFinalObj}
            defaultValue={currentData?.project_incharge}
          /> */}
          <TextInput
            title="Flight Status"
            objKey="flight_status"
            setFinalObj={setFinalObj}
            defaultValue={currentData?.flight_status}
            type="url"
            required
          />
          <div className="p-2  w-full flex gap-3">
            <button
              type="button"
              className="ring-1 ring-slate-300  uppercase w-full text-xs rounded-md py-2 flex justify-center items-center gap-2"
              disabled={submitLoading}
              onClick={() => setPopupState({ open: false })}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={
                disable
                  ? "bg-red opacity-50 uppercase w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
                  : "bg-red uppercase w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              }
              disabled={submitLoading || disable}
            >
              Submit
              {submitLoading && <CgSpinner className="animate-spin" />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export const TextInput = ({
  title,
  type,
  objKey,
  setFinalObj,
  defaultValue,
  required = false,
}) => {
  return (
    <div className={`form-control w-full gap-[0.15rem] mb-4`}>
      <label className="label py-0">
        <span className="label-text">{title}</span>
      </label>
      <input
        required={required}
        defaultValue={defaultValue}
        type={type || "text"}
        placeholder="Type here"
        className="input input-sm input-bordered w-full"
        onChange={(e) =>
          setFinalObj((prevState) => ({
            ...prevState,
            [objKey]:
              type == "date"
                ? String(e.target.value).split("-").reverse().join("-")
                : e.target.value,
          }))
        }
      />
    </div>
  );
};

export const ArraySelectInput = ({
  title,
  array,
  objKey,
  setFinalObj,
  defaultValue,
  required = false,
}) => {
  return (
    <div className={`form-control w-full gap-[0.15rem] mb-4 `}>
      <label className="label py-0">
        <span className="label-text">{title}</span>
      </label>
      <select
        required={required}
        defaultValue={defaultValue}
        className="select select-sm select-bordered"
        onChange={(e) =>
          setFinalObj((prevState) => ({
            ...prevState,
            [objKey]: e.target.value,
          }))
        }
      >
        <option value="" hidden>
          Select an Option
        </option>
        {array?.map((data) => (
          <option value={data?.id || data} key={data?.id || data}>
            {data?.name || data}
          </option>
        ))}
      </select>
    </div>
  );
};
